import Swiper from 'swiper';

class ListSlider {
  constructor() {
    this.component = document.querySelector('[data-component="list-slider"]');
    this.trigger = document.querySelector('[data-trigger="list-slider"]');
    this._init();
  }

  _init() {
    if (this.component && this.trigger) {
      var mySwiper = new Swiper(this.trigger, {
        spaceBetween: 60,
        slidesPerView: 4,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          380: {
            slidesPerView: 1,
            spaceBetween: 20
          },
          668: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          1023: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1200: {
            spaceBetween: 60,
            slidesPerView: 4,
          },

        }
      });
    }
  }
}

export const listSlider = new ListSlider();
